/**
 * BenchRosterCards — the org-wide employees as a card grid (demo /teams member cards).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../../components/ui/index.js';
import { Avatar, type EmployeeView } from '../shared';
import { AssignmentsCell, AttentionCell, CurrentFocusCell, LifecycleBadge, LoadCell, SkillChips } from './cells.js';

export const BenchRosterCards: React.FC<{ employees: EmployeeView[] }> = ({ employees }) => (
  <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
    {employees.map((emp) => {
      const attn = emp.attention.level !== 'clear';
      const terminated = emp.lifecycle === 'terminated';
      return (
        <Card key={emp.id} className={`${attn ? 'border-danger' : ''} ${terminated ? 'opacity-60' : ''}`}>
          <div className="flex flex-col gap-3">
            <div className="flex items-start justify-between gap-2">
              <div className="flex items-center gap-2.5">
                <Avatar
                  label={emp.name}
                  kind={emp.kind}
                  initials={emp.initials}
                  size={36}
                  lifecycle={emp.lifecycle}
                  showKind
                />
                <div className="min-w-0">
                  <Link to={`/workforce/${emp.id}`} className="font-medium leading-tight text-heading hover:underline">
                    {emp.name}
                  </Link>
                  <div className="text-xs text-muted">
                    {emp.role}
                    {emp.tier ? ` · ${emp.tier}` : ''}
                  </div>
                </div>
              </div>
              <LifecycleBadge lifecycle={emp.lifecycle} />
            </div>
            <SkillChips skills={emp.skills} />
            <div className="flex items-center justify-between gap-3">
              <LoadCell load={emp.load} lifecycle={emp.lifecycle} />
              <AttentionCell attention={emp.attention} />
            </div>
            <div className="flex items-end justify-between gap-3 border-t border-border pt-3">
              <AssignmentsCell assignments={emp.assignments} terminated={terminated} />
              <CurrentFocusCell focus={emp.currentFocus} />
            </div>
          </div>
        </Card>
      );
    })}
  </div>
);
